/*
 * Tabs content component
 *
 * @param {String} tab Active tab
 *
 * @return {Element}
 */
<template>
  <div class="tab-content reward-tab-content">
    <div id="top" class="tab-pane" :class="activeTab('top')">
      <top :currentTab="tab" @checkData="checkData"></top>
    </div>
    <div id="affiliater-list" class="tab-pane" :class="activeTab('affiliater-list')">
      <affiliater-list :currentTab="tab"></affiliater-list>
    </div>
    <div id="reward-info" class="tab-pane" :class="activeTab('reward-info')">
      <reward-info :currentTab="tab"></reward-info>
    </div>
  </div>
</template>
<script>
import Top from './Top'
import AffiliaterList from './AffiliaterList'
import RewardInfo from './RewardInfo'
export default {
  components: {
    Top,
    AffiliaterList,
    RewardInfo
  },
  props: {
    tab: {
      type: String,
      default: 'top'
    }
  },
  methods: {
    /*
     * Check data to disable/enable tab
     *
     * @param {Boolean} hasData User information exist or not
     *
     * @return void
     */
    checkData (hasData) {
      this.$emit('checkData', hasData)
    },
    /*
     * Check tab is active or not
     *
     * @param {String} tabName Tab's name
     *
     * @return {String}
     */
    activeTab (tabName) {
      return this.tab === tabName ? 'active' : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/affiliate/TabContent.vue